const DefaultConfig = {
  showBalance: true,
  seeCards: false,
  hasCreditTooltipBeenShown: false,
};

export default DefaultConfig;
